import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "ab28f2bd-a080-4288-9bbc-e2c19180f072", content: "10 g", options: {} },
  { id: "40aa8459-e02d-435b-9de1-9d6a9cedfc6b", content: "10.4 g", options: {} },
  { id: "b55174b3-ce74-409e-a1e5-d7f4b1481b77", content: "10.9 g", options: {} },
  { id: "b502ffa3-7850-4f59-8378-c392d664ace5", content: "11.8 g", options: {} },
  { id: "6d20560f-24d6-43f9-a3a9-636915f59f8a", content: "12.2 g", options: {} },
  { id: "311124ea-841e-43d4-8f7d-59f84b14920b", content: "12.6 g", options: {} },
];

export const task: Task = {
  id: "2469a1d3-5d06-41d6-9c80-d2bc79c7200c",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["b55174b3-ce74-409e-a1e5-d7f4b1481b77"],
};
